import React from "react";
import SuccessIcon from "../../../assets/images/icons/success-icon.svg";
import "./loginSuccessPage.css";

export const LoginSuccessPage = () => {
  return (
    <div className="login-success-page">
      <div className="mobile-device-container">
        <img src={SuccessIcon} alt="success-icon" />
        <h4 className="success-title">Successful</h4>
        <p className="success-detail">Authentication successfully</p>
      </div>
    </div>
  );
};
